import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroSection from '@/pages/home/components/HeroSection';
import TickerBar from '@/pages/home/components/TickerBar';
import RankingList from '@/pages/home/components/RankingList';
import NewsTimeline from '@/pages/home/components/NewsTimeline';
import SiteNav from '@/pages/home/components/SiteNav';
import HotResources from '@/pages/home/components/HotResources';
import NightPicks from '@/pages/home/components/NightPicks';
import CategoryCloud from '@/pages/home/components/CategoryCloud';
import FaqSection from '@/pages/home/components/FaqSection';
import SubscribeBox from '@/pages/home/components/SubscribeBox';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1">
        <HeroSection />
        <TickerBar />

        <section className="px-4 md:px-8 py-10 md:py-14">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            <div className="lg:col-span-8">
              <p className="text-xs tracking-[0.25em] text-foreground-400 font-label">EDITOR&apos;S NOTE · 本期导读</p>
              <p className="mt-4 font-heading text-lg md:text-2xl leading-relaxed text-foreground-900">
                这一期，我们把能用的看片入口重新巡了一遍线：当前还能打开的高清站点、每日在更新热门小电影资源，以及深夜档里适合安静看完的片单，全部收进了这一页。你不用再一个个搜网址，找到标着「在线」的入口，打开就能直接播。
              </p>
            </div>

            <div className="lg:col-span-4 w-full rounded-lg border border-foreground-950/12 bg-background-100 p-5 md:p-6">
              <p className="text-xs tracking-[0.25em] text-secondary-900 font-label">本期关键词</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {['小电影免费观看', '高清小电影', '每日更新', '深夜档', '站点巡检'].map((word) => (
                  <span
                    key={word}
                    className="text-xs px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200 whitespace-nowrap"
                  >
                    {word}
                  </span>
                ))}
              </div>
              <div className="mt-5 pt-4 border-t border-foreground-950/10 flex items-baseline gap-2">
                <span className="font-heading font-black text-3xl text-primary-600">97.4%</span>
                <span className="text-xs text-foreground-500 leading-relaxed">
                  当前收录站点的在线可播放率，每小时更新一次
                </span>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 border-t border-foreground-950/10">
          <div className="px-4 md:px-8 py-12 md:py-16">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-12">
              <RankingList />
              <NewsTimeline />
            </div>
          </div>
        </section>

        <SiteNav />
        <HotResources />
        <NightPicks />
        <CategoryCloud />
        <FaqSection />
        <SubscribeBox />
      </main>

      <SiteFooter />
    </div>
  );
}